import {
  NationalityCountryModel,
  NationalityCountryDto,
} from '@marketplace-web/pay-identity/payments-identity-data'

import { transformAddress } from '@marketplace-web/pay-identity/payments-address-data'

import { transformPepDetails } from '@marketplace-web/pay-identity/politically-exposed-person-data'

import type {
  DynamicConfigurationDto,
  PaymentsAccountDto,
  RequirementsDto,
  DynamicConfigurationModel,
  PaymentsAccountModel,
  RequirementsModel,
  CreatePaymentsAccountArgs,
} from '../types/payments-account'

export const transformNationality = (
  nationality: NationalityCountryDto,
): NationalityCountryModel => ({
  code: nationality.code,
  title: nationality.title,
})

export const transformPaymentsAccount = (
  paymentsAccount: PaymentsAccountDto,
): PaymentsAccountModel => ({
  firstName: paymentsAccount.first_name,
  lastName: paymentsAccount.last_name,
  birthdate: paymentsAccount.birthdate,
  nationality: paymentsAccount.nationality
    ? transformNationality(paymentsAccount.nationality)
    : null,
  address: paymentsAccount.user_address ? transformAddress(paymentsAccount.user_address) : null,
  pepDetails: paymentsAccount.pep_details ? transformPepDetails(paymentsAccount.pep_details) : null,
  balanceActivated: paymentsAccount.balance_activated,
})

export const transformDynamicConfiguration = (
  dynamicConfiguration: DynamicConfigurationDto,
): DynamicConfigurationModel => ({
  showInformationHint: dynamicConfiguration.show_information_hint,
  agreementHint: dynamicConfiguration.agreement_hint,
  personalIdNumberRequiredNationalities:
    dynamicConfiguration.personal_id_number_required_nationalities,
  addressType: dynamicConfiguration.address_type,
  lockedFields: dynamicConfiguration.locked_fields,
  maskedFields: dynamicConfiguration.masked_fields,
  bannedNationalities: dynamicConfiguration.banned_nationalities || [],
})

export const transformRequirements = (requirements: RequirementsDto): RequirementsModel => ({
  ssnSerial: requirements.ssn_serial,
  nationality: requirements.nationality,
  pepDeclaration: requirements.pep_declaration,
})

export const createPaymentsAccountArgsToParams = (args: CreatePaymentsAccountArgs) => {
  return {
    payments_account: {
      user_address_id: args.addressId,
      first_name: args.firstName || undefined,
      last_name: args.lastName || undefined,
      birthdate: args.birthdate || undefined,
      ssn_serial: args.ssnNumber || undefined,
      personal_id_number: args.personalIdNumber || undefined,
      nationality: args.nationality ? { code: args.nationality.code } : undefined,
      pep_details: args.pepDetails
        ? {
            type: args.pepDetails.type,
            position: args.pepDetails.position,
            organisation: args.pepDetails.organisation,
            holds_position_from: args.pepDetails.holdsPositionFrom,
            associated_pep_full_name: args.pepDetails.associatedPepFullName,
          }
        : undefined,
    },
  }
}
